<template>
  <div class="container">
    <el-row style="margin-bottom:20px">
        <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/director-work' }">工作台</el-breadcrumb-item>
        <el-breadcrumb-item >发布</el-breadcrumb-item>
      </el-breadcrumb>
    </el-row>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="招聘需求" name="first" lazy>
        <DemandZp></DemandZp>
      </el-tab-pane>
      <el-tab-pane label="众包需求" name="second" lazy>
        <DemandZb></DemandZb>
      </el-tab-pane>

      <el-tab-pane label="推广信息" name="third" lazy>
        <DemandZb></DemandZb>
      </el-tab-pane>

      <el-tab-pane label="资源共享" name="forth" lazy>
        <DemandZb></DemandZb>
      </el-tab-pane>


      <el-tab-pane label="公告通知" name="five" lazy>
        <DemandZb></DemandZb>
      </el-tab-pane>


    </el-tabs>
  </div>
</template>

<script>
import DemandZb from "./demand-zb.vue";
import DemandZp from "./demand-zp.vue";
export default {
  components: {
    DemandZb, DemandZp
  },
  data () {
    return {
      activeName: 'first'
    };
  },
  methods: {
    handleClick (tab, event) {
      console.log(tab, event);
    }
  }
};
</script>

